import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';

const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {clerkKey ? (
      <ClerkProvider
        publishableKey={clerkKey}
        localization={{
          signIn: {
            start: {
              title: 'Sign in to Procurement Forecast Bot',
              subtitle: 'Sign in to submit queries and start your free 1-day trial',
            },
          },
        }}
      >
        <App />
      </ClerkProvider>
    ) : (
      <div role="alert" style={{ padding: 24 }}>
        Optibot authentication is not configured. Set REACT_APP_CLERK_PUBLISHABLE_KEY.
      </div>
    )}
  </React.StrictMode>
);
